import React from 'react'

class Display extends React.Component {
  static defaultProps = {
    if: false,
    delay: 0,
  }

  state = {
    finished: false
  }

  componentDidMount() {
    if(!this.props.if) return

    this.check()
  }

  componentDidUpdate(prevProps, prevState) {
    if(prevProps.if !== this.props.if) {
      this.check()
    }
  }

  check() {
    if(!this.props.if) {
      this.setState({ finished: false })
      return
    }

    if(this.props.delay) {
      this.timeout = setTimeout(() => {
        this.setState({ finished: true })
      }, this.props.delay)
    } else {
      this.setState({ finished: true })
    }
  }

  componentWillUnmount() {
    if(this.timeout) clearTimeout(this.timeout)
  }

  render() {
    return this.props.if && this.state.finished ? this.props.children : null
  }
}

export default Display
